import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function SearchBar() {
  const [value, setValue] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearchClick = () => {
    const trimmed = value?.trim();
    const params = new URLSearchParams(
      location.pathname.includes("/search") ? location.search : ""
    );
    if (trimmed) {
      params.set("query", trimmed);
    } else {
      params.delete("query");
    }
    params.delete("page");
    const search = params.toString();
    navigate({ pathname: "/search", search: search ? `?${search}` : "" });
  };

  const handleInputChange = (e) => {
    const next = e.target.value;
    setValue(next);
    if (!next.trim() && location.pathname.includes("/search")) {
      const params = new URLSearchParams(location.search);
      if (!params.has("query")) return;
      params.delete("query");
      params.delete("page");
      const search = params.toString();
      navigate({ pathname: "/search", search: search ? `?${search}` : "" }, { replace: true });
    }
  };

  return (
    <div className="w-full transition-all duration-200 ease-in-out">
      <div className="w-full flex flex-col justify-center flex-shrink-0 relative z-30">
        <div className="flex flex-col w-full">
          <div className="relative pr-12 md:pr-14 bg-white overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-200 rounded-lg w-full">
            <label className="flex items-center py-0.5">
              <input
                value={value}
                name="value"
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    handleSearchClick()
                  }
                }}
                onChange={handleInputChange}
                className="form-input w-full pl-5 appearance-none transition ease-in-out border text-input text-sm [@media(display-mode:standalone)]:text-base font-sans rounded-lg min-h-10 h-11 [@media(display-mode:standalone)]:h-12 duration-200 bg-white focus:ring-0 outline-none border-none focus:outline-none placeholder-gray-500 placeholder-opacity-75"
                placeholder="Search for products"
              />
            </label>
            <button
              type="submit"
              onClick={() => handleSearchClick()}
              aria-label="Search"
              className="outline-none text-xl text-gray-400 absolute top-0 right-0 end-0 w-12 [@media(display-mode:standalone)]:w-14 h-full flex items-center justify-center transition duration-200 ease-in-out hover:text-brand-600 focus:outline-none"
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                height="1.2em"
                width="1.2em"
                xmlns="http://www.w3.org/2000/svg"
                className="transform hover:scale-110 transition-transform duration-200"
              >
                <path
                  fill="none"
                  strokeMiterlimit="10"
                  strokeWidth="32"
                  d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"
                ></path>
                <path
                  fill="none"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="32"
                  d="M338.29 338.29L448 448"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
